/** CIE-10 de uso frecuente en odontología (capítulo K00–K14 y afines). Sugerencias, no el catálogo OMS completo. */
export interface Cie10Entry {
  code: string;
  label: string;
}

export const CIE10_ODONTOLOGIA: Cie10Entry[] = [
  { code: 'K02.1', label: 'Caries de la dentina' },
  { code: 'K02.2', label: 'Caries del cemento' },
  { code: 'K02.3', label: 'Caries detenida' },
  { code: 'K02.9', label: 'Caries dental, no especificada' },
  { code: 'K04.0', label: 'Pulpitis' },
  { code: 'K04.1', label: 'Necrosis de la pulpa' },
  { code: 'K04.4', label: 'Periodontitis apical aguda de origen pulpar' },
  { code: 'K04.5', label: 'Periodontitis apical crónica' },
  { code: 'K04.7', label: 'Absceso periapical sin fístula' },
  { code: 'K05.0', label: 'Gingivitis aguda' },
  { code: 'K05.1', label: 'Gingivitis crónica' },
  { code: 'K05.2', label: 'Periodontitis aguda' },
  { code: 'K05.3', label: 'Periodontitis crónica' },
  { code: 'K05.6', label: 'Enfermedad periodontal, no especificada' },
  { code: 'K08.1', label: 'Pérdida de dientes por accidente, extracción o enfermedad periodontal local' },
  { code: 'K08.8', label: 'Otros trastornos especificados de los dientes y de sus estructuras de sostén' },
  { code: 'K01.0', label: 'Dientes incluidos' },
  { code: 'K01.1', label: 'Dientes impactados' },
  { code: 'K00.6', label: 'Alteraciones en la erupción dentaria' },
  { code: 'K07.4', label: 'Maloclusión, no especificada' },
  { code: 'K12.0', label: 'Estomatitis aftosa recurrente' },
  { code: 'K13.0', label: 'Enfermedades de los labios' },
  { code: 'K14.0', label: 'Glositis' },
  { code: 'S02.5', label: 'Fractura de diente' },
  { code: 'K10.2', label: 'Afecciones inflamatorias de los maxilares' },
];

export const RECETA_REQUIRED_KEYS = [
  'numeroSecuencial',
  'ciudad',
  'fechaIso',
  'establecimiento',
  'vigencia',
  'pacienteApellidosNombres',
  'edad',
  'diagnosticoCie',
  'alergias',
  'medicamentos',
  'prescriptorNombre',
  'registroAcess',
  'telefonoPrescriptor',
  'indicaciones',
  'signosAlarma',
  'recomendacionesNoFarmacologicas',
] as const;

export const MEDICAMENTO_REQUIRED_KEYS = [
  'dci',
  'formaFarmaceutica',
  'concentracion',
  'via',
  'cantidadNumero',
  'cantidadLetras',
  'dosis',
  'frecuencia',
  'duracion',
] as const;
